import { SectionContainer } from "../atoms/containers/ContentContainers";
import { SectionTwoContent } from "../molecules/section_two_content/SectionTwoContent";

export function SectionTwo() {
	return (
		<SectionContainer id="services" variant="light">
			<SectionTwoContent />
		</SectionContainer>
	);
}
